import React, { useMemo } from 'react';

import { DataTableProps } from './DataTable.decl';
import { Table } from './Table';
import { TableBody } from './TableBody';
import { TableHeader, TableHeaderCell } from './TableHeader';
import { TableRow, RowWrapper } from './TableRow';

export function DataTable<T>({
  className,
  data,
  emptyMessage,
  columns,
  rowRenderer,
  tableBodyRef,
  ...restProps
}: DataTableProps<T>) {
  const dataTest = restProps['data-test'];

  const tableHeader = useMemo(
    () =>
      columns.map(({ width, name }) => (
        <TableHeaderCell key={name} width={width}>
          <span>{name}</span>
        </TableHeaderCell>
      )),
    [columns]
  );

  const rows = useMemo(
    () =>
      data &&
      data.map((datum, rowIndex) => (
        <TableRow<T>
          // eslint-disable-next-line react/no-array-index-key
          key={rowIndex}
          columns={columns}
          datum={datum}
          rowIndex={rowIndex}
          rowRenderer={rowRenderer}
        />
      )),
    [columns, data, rowRenderer]
  );

  if (!data || data.length === 0) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{emptyMessage}</>;
  }

  return (
    <Table className={className} data-test={dataTest || 'data-table'}>
      <TableHeader data-test='table-header'>
        <RowWrapper>{tableHeader}</RowWrapper>
      </TableHeader>

      <TableBody ref={tableBodyRef} data-test='table-body'>
        {rows}
      </TableBody>
    </Table>
  );
}
